import React from "react";
import  Fade  from "react-reveal/Fade";
const Custoize = () => {
  return (
    <svg
      width="21"
      height="27"
      viewBox="0 0 21 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.99294 24.6266C2.99294 24.4723 2.99294 24.3643 2.99294 24.2562C2.9947 23.1773 2.97184 22.0972 3.00408 21.0188C3.05859 19.1954 3.78366 17.6812 5.12301 16.4834C5.61479 16.0433 6.13529 15.6362 6.63997 15.2112C7.76889 14.2607 7.76069 12.7597 6.6259 11.8093C6.0673 11.3416 5.48349 10.8997 4.96299 10.3905C3.67464 9.13211 2.9988 7.58368 2.99412 5.74645C2.99177 4.74739 2.99353 3.74772 2.99353 2.74866C2.99353 2.64118 2.99353 2.53371 2.99353 2.38902C2.37221 2.38902 1.7802 2.39502 1.18819 2.38721C0.534629 2.37881 0.0381602 1.90269 0.00181886 1.26507C-0.0356947 0.614833 0.442017 0.054059 1.07799 0.0036254C1.14598 -0.00177821 1.21456 0.000623395 1.28256 0.000623395C7.42893 0.000623395 13.5747 0.000623395 19.7211 0.000623395C20.4133 0.000623395 20.9074 0.387881 20.9878 0.989483C21.0839 1.70756 20.5851 2.32777 19.8782 2.34759C19.3711 2.362 18.8635 2.35119 18.3565 2.35179C18.2522 2.35179 18.1484 2.35179 18.0089 2.35179C18.0089 2.49649 18.0089 2.60336 18.0089 2.71023C18.0089 3.7195 18.0148 4.72878 18.0072 5.73805C17.9919 7.7632 17.1883 9.40409 15.6825 10.6962C15.2564 11.0618 14.8203 11.4154 14.3877 11.7733C13.226 12.7345 13.2301 14.2481 14.3965 15.213C14.8138 15.5582 15.2329 15.9016 15.6462 16.2517C17.1965 17.5647 18.0037 19.2435 18.0083 21.3136C18.0107 22.2929 18.0083 23.2721 18.0083 24.2514C18.0083 24.3601 18.0083 24.4681 18.0083 24.6098C18.1332 24.6164 18.2364 24.626 18.3389 24.6266C18.8559 24.629 19.3735 24.6176 19.8899 24.632C20.5065 24.6489 20.9631 25.1394 20.9772 25.7746C20.9913 26.3942 20.5405 26.9298 19.9503 26.9904C19.8535 27.0006 19.7557 27.0006 19.6578 27.0006C13.5407 27.0006 7.42424 27.0012 1.30718 27.0006C0.544594 27.0006 0.0410909 26.5689 0.00123271 25.8869C-0.0380393 25.2192 0.45081 24.6525 1.10495 24.632C1.61197 24.6164 2.11958 24.6278 2.6266 24.6272C2.73269 24.6272 2.8382 24.6272 2.99177 24.6272L2.99294 24.6266ZM5.31937 2.3608C5.30589 2.41543 5.29241 2.44305 5.29241 2.47127C5.29241 3.64986 5.27424 4.82964 5.30355 6.00763C5.32113 6.7185 5.55266 7.38074 5.96765 7.95773C6.03858 8.05679 6.19743 8.14385 6.31641 8.14445C9.1059 8.15466 11.8954 8.15466 14.6849 8.14445C14.8039 8.14445 14.9645 8.05799 15.0336 7.95893C15.4902 7.30749 15.7048 6.5684 15.7095 5.76867C15.7153 4.71977 15.7118 3.67087 15.7106 2.62197C15.7106 2.53731 15.6972 2.45206 15.6895 2.3608H5.31937ZM15.7106 24.3847C15.7106 23.2944 15.7206 22.2473 15.7077 21.2008C15.6931 19.9952 15.2347 18.9913 14.3344 18.2108C13.8361 17.7785 13.3227 17.3642 12.8156 16.9421C12.1041 16.3495 11.6357 15.5948 11.396 14.6918C11.335 14.4619 11.3004 14.2241 11.2448 13.9455C11.0976 14.3106 10.8749 14.5261 10.5121 14.5315C10.1387 14.5375 9.91069 14.3178 9.75243 13.9533C9.72898 14.0626 9.71081 14.1292 9.69967 14.1977C9.508 15.3601 8.96171 16.3081 8.06256 17.0448C7.60536 17.4188 7.1464 17.7905 6.7021 18.1807C5.77716 18.9925 5.29475 20.0234 5.29007 21.2782C5.28655 22.2172 5.28889 23.1563 5.29007 24.0953C5.29007 24.1793 5.30003 24.264 5.30706 24.3739C5.42253 24.3234 5.51104 24.2874 5.59838 24.246C6.93304 23.6144 8.27298 22.9942 9.59944 22.3451C10.2079 22.0473 10.7799 22.0371 11.3907 22.3367C12.6375 22.9491 13.8977 23.5321 15.1526 24.1265C15.3267 24.2088 15.502 24.2886 15.7101 24.3847H15.7106Z"
        fill="#E21F27"
      />
    </svg>
  );
};

const Automate = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8372 3.18343e-06C19.9271 0.00491202 25.6824 5.70714 25.6657 12.7108C25.6483 19.7151 19.9023 25.3879 12.8285 25.383C5.74047 25.3787 -0.0173335 19.6728 3.921e-05 12.6716C0.0174119 5.66787 5.76404 -0.00490566 12.8372 3.18343e-06ZM3.66319 12.6826C3.65823 17.6724 7.7619 21.7462 12.8087 21.7609C17.8666 21.7756 21.9976 17.7043 22.0032 12.7004C22.0087 7.70933 17.9063 3.63745 12.8577 3.62273C7.80161 3.608 3.66816 7.6805 3.66319 12.6826Z"
        fill="#E21F27"
      />
      <path
        d="M10.9967 10.8835C10.9967 10.2816 10.9825 9.67902 10.9998 9.07708C11.0284 8.08979 11.6972 7.36819 12.6633 7.25651C13.5114 7.15834 14.3534 7.72162 14.5879 8.56533C14.6475 8.77825 14.6655 9.00774 14.6679 9.23048C14.6772 10.0466 14.6605 10.8633 14.681 11.6794C14.6853 11.8395 14.774 12.0328 14.8882 12.1482C15.848 13.1183 16.8321 14.0651 17.7901 15.037C18.7189 15.9801 18.4161 17.5105 17.2118 17.9756C16.4877 18.2548 15.7928 18.1572 15.2301 17.6142C13.9755 16.4017 12.7427 15.1671 11.5061 13.9368C11.1369 13.5693 10.9961 13.1078 10.9961 12.5986C10.9961 12.0273 10.9961 11.4554 10.9961 10.8841H10.9973L10.9967 10.8835Z"
        fill="#E21F27"
      />
    </svg>
  );
};

const EarnReturn = () => {
  return (
    <svg
      width="27"
      height="21"
      viewBox="0 0 27 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.93846 13.4666V7.37637C2.56663 7.11628 3.19675 6.92645 3.7591 6.60758C5.27868 5.74692 6.22744 4.41201 6.59561 2.65082C6.63927 2.44342 6.72594 2.38532 6.92338 2.38532C11.3101 2.39073 15.6975 2.39073 20.0842 2.38532C20.2856 2.38532 20.3585 2.45491 20.4094 2.65487C21.0597 5.2166 22.6171 6.79944 25.1434 7.30341C25.5005 7.37435 25.8791 7.37772 26.2433 7.34867C26.6428 7.31625 26.9673 7.00954 26.9719 6.60691C26.9862 5.41589 27.054 4.21069 26.9119 3.03589C26.7216 1.46453 25.4086 0.389714 23.8773 0.388363C16.9603 0.382959 10.0433 0.381607 3.12572 0.388363C1.40218 0.39039 0.0239961 1.77934 0.0161767 3.56823C-0.00402366 8.1053 -0.00402366 12.6417 0.0161767 17.1788C0.0239961 18.9501 1.4517 20.3782 3.16091 20.3796C10.0564 20.3843 16.9519 20.385 23.8473 20.3796C25.6484 20.3782 26.9849 18.9791 26.9973 17.1065C27.0031 16.2397 27.0012 15.373 26.9973 14.5062C26.994 13.7131 26.6278 13.3544 25.8635 13.3855C23.2283 13.4936 21.0245 15.3703 20.4244 18.0367C20.367 18.2907 20.2908 18.384 20.0282 18.384C15.674 18.3752 11.3192 18.3765 6.96508 18.3819C6.7507 18.3819 6.64839 18.3394 6.58975 18.0928C6.01502 15.677 4.55668 14.1617 2.22844 13.549C2.1346 13.5247 2.04207 13.4963 1.93846 13.4666Z"
        fill="#E21F27"
      />
      <path
        d="M13.4973 15.3824C16.1924 15.3845 18.3187 13.1869 18.3232 10.3968C18.3278 7.58713 16.2002 5.38075 13.4901 5.3848C10.7983 5.38886 8.67856 7.59321 8.67987 10.3867C8.68117 13.1788 10.8042 15.3804 13.4967 15.3824H13.4973Z"
        fill="#E21F27"
      />
      <path
        d="M25.0833 10.3812C25.0833 10.9778 25.469 11.3844 26.0372 11.3858C26.6061 11.3872 26.9945 10.9818 26.9951 10.3853C26.9951 9.79012 26.6081 9.38209 26.0405 9.38141C25.4716 9.38073 25.0833 9.78607 25.0826 10.3812H25.0833Z"
        fill="#E21F27"
      />
    </svg>
  );
};
const Summery = () => {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.00823 18.1993C1.00823 18.0585 1.00823 17.9276 1.00823 17.7966C1.00823 12.7405 1.00823 7.68439 1.00823 2.62764C1.00883 1.22961 1.82046 0.384864 3.16548 0.384246C3.79735 0.384246 4.42922 0.383011 5.06109 0.384246C6.30169 0.387951 7.14952 1.25802 7.15248 2.5486C7.15782 4.96366 7.15426 7.37872 7.15426 9.79378C7.15426 12.4453 7.15426 15.0969 7.15426 17.7479V18.1727H8.43698V17.788C8.43698 14.4584 8.4352 11.1288 8.43817 7.79862C8.43876 6.75257 9.02317 5.94549 9.94931 5.70837C10.1101 5.667 10.281 5.65465 10.4477 5.65341C11.1585 5.64786 11.8698 5.64662 12.5806 5.65218C13.734 5.66082 14.5812 6.53891 14.583 7.73811C14.5866 11.0881 14.5842 14.4387 14.5842 17.7886C14.5842 17.9096 14.5842 18.0313 14.5842 18.1708H15.8806C15.8806 18.0535 15.8806 17.935 15.8806 17.8158C15.8806 15.7502 15.88 13.6847 15.8806 11.6185C15.8812 10.2816 16.7029 9.43069 17.9939 9.4276C18.6554 9.42637 19.317 9.42451 19.9785 9.4276C21.18 9.43501 22.0201 10.3082 22.0242 11.571C22.0308 13.647 22.026 15.7231 22.026 17.7985C22.026 17.9189 22.026 18.0387 22.026 18.1542C22.2426 18.1881 22.43 18.1993 22.6068 18.2499C22.8762 18.3277 23.0228 18.5765 22.9967 18.8618C22.9711 19.1372 22.7694 19.3435 22.49 19.3731C22.3921 19.3836 22.293 19.3805 22.1939 19.3805C15.0648 19.3805 7.93564 19.3805 0.806509 19.3805C0.697934 19.3805 0.588173 19.3836 0.481379 19.37C0.207866 19.3342 0.0138555 19.1138 0.000802858 18.8341C-0.0134364 18.5358 0.162775 18.2857 0.446374 18.2363C0.619618 18.206 0.798203 18.2104 1.00823 18.1974V18.1993Z"
        fill="#E21F27"
      />
    </svg>
  );
};
const Target = () => {
  return (
    <Fade bottom>
      <div className="md:py-[4.6rem] py-[2rem] lg:px-[64px] px-[1rem] bg-[#F6F6F694]">
        <div className="lg:flex max-w-[1520px] mx-auto gap-[60px]">
          <div className="flex-1">
            <div className="max-w-[546px] max-h-[409px] mx-auto">
              <img
                src="/images/tardetimg.png"
                alt=""
                className="w-full h-[100%] object-cover"
              />
            </div>
          </div>
          <div className="flex-1">
            <div className="md:mt-0 mt-10">
              <h1 className="text-[39px] text-[#333333] font-extrabold">
                Target Savings
              </h1>
              <p className="md:text-[20px] text-[1rem] md:my-[40px] my-10 font-normal leading-10 md:leading-[32px]">
                Need to go on vacation with friends? Buy that new wig or propose
                to your girl? Save towards multiple goals with ease. 
              </p>
              <ul>
                <li className="flexx md:mb-[20px] mb-10">
                  <Custoize />
                  <span className="flexx-span">Customise saving duration</span>
                </li>
                <li className="flexx  md:mb-[20px] mb-10">
                  <Automate />{" "}
                  <span className="flexx-span">Automate savings</span>
                </li>
                <li className="flexx  md:mb-[20px] mb-10">
                  <EarnReturn />{" "}
                  <span className="flexx-span">Earn amazing returns</span>
                </li>
                <li className="flexx">
                  <Summery /> <span className="flexx-span">Track Progress</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default Target;
